/**
 * @function delegate
 *
 * @description This function is used to delegate a child event to a parent element.
 * @param {Object} options
 * @param {string} options.target The css selector to target for the event
 * @param {string} options.delegateTo The Node to attach the event
 * @param {boolean} options.useCapture Default(false). Use true for capture and False for bubbling
 * @param {function} options.listener Function to use when executing the event
 * @param {string} options.event the events to listen
 */

export default function delegate(options) {
  // Add default arguments
  let defaultOptions = {
    target : null,
    event:'',
    listener : () => {},
    useCapture : false,
    delegateTo : 'body'
  };

  // Merge opts and defaultOptions in options
  const opts = {...defaultOptions, ...options};
  // Multiple event handling
  opts.event.split(' ').map((eventName) => {
  // Delegate the listener to opts.delegateTo
    document.querySelector(opts.delegateTo).addEventListener(eventName, (e)=>{
      let eTemp = {};

      for (let prop in e) {
        eTemp[prop] = e[prop];
      }
      let evt = {
        originalEvent : e,
        stopPropagation : e.stopPropagation.bind(e),
        stopImmediatePropagation : e.stopImmediatePropagation.bind(e),
        preventDefault: e.preventDefault.bind(e),
      };

      evt = {...eTemp,...evt};

      // Check if the event is fired by the correct element.
      // console.log(e.target,e.target.closest)
      if (e.target.closest(opts.target)) {
        evt.target = e.target.closest(opts.target);
        evt.currentTarget = opts.delegateTo;
        // Execute the listener, pass the Event to the listener and use null as this (You need to use bind to change the "this" of your listener)
        opts.listener.call(null,evt)
      }
    });
  });
}
